import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Spinnable from '../../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper.jsx';
import categoriesApi from './../../../api/Categories.api';
import xhr from './../../../utils/xhr';
import utils from './../../../utils/utilities';
import popupActions from '../../../reusable/MessagePopup/redux/MessagePopup.actions';
import CategoryName from './EditCategories.CategoryName';
import {
    ModalRemovedCategoryIsOrphaned,
    ModalRemovedCategoryIsOrphanedLinked
} from '../../../reusable/Modal/ModalBodies';

import {
    POPUP_LIFETIME,
    VALIDATION_ICON_VALID,
    VALIDATION_ICON_INVALID,
    VALIDATION_ICON_LOADING
} from '../../../constants';
const SELECT_OPTION = "selectCategory";
const codesToMessageIdsMap = {
    'api.error.category.duplicate':           'Entities_Review_UIText_reviewCompanies.categoryNameAlreadyExists',
    'api.error.category.maximumSizeExceeded': 'Entities_Review_UIText_reviewCompanies.categoryMaxNameLengthExceeded',
    'none':                                   'Entities_Review_Error_reviewCompanies.unknownError'
};

class EditCategories extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            categories:                        this.props.data,
            categoryStore:                     {},
            selectedCategory:                  SELECT_OPTION,
            tempCatName:                       '',
            tempCategoriesNames:               [],
            isTempCategoryNameValid:           false,
            entityName:                        this.props.companyTitle,
            entityId:                          this.props.companyId,
            orphanCategoryModal: false,
            orphanCategoryLinkedModal: false,
            activeModal: null
        };

        this.generateCategoryOptions = this.generateCategoryOptions.bind(this);
        this.generateCategoryLabels = this.generateCategoryLabels.bind(this);
        this.selectCategory = this.selectCategory.bind(this);
        this.testCategory = this.testCategory.bind(this);
        this.toggleOrphanCategoryModal = this.toggleOrphanCategoryModal.bind(this);
        this.toggleOrphanCategoryLinkedModal = this.toggleOrphanCategoryLinkedModal.bind(this);
        this.removeCategory = this.removeCategory.bind(this);
        this.loadCategories = this.loadCategories.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.generateTempCategoryLabels = this.generateTempCategoryLabels.bind(this);
        this.addCategory = this.addCategory.bind(this);
        this.setTempCatName = this.setTempCatName.bind(this);
        this.removeTempCategory = this.removeTempCategory.bind(this);
        this.validateTempCategoryName = this.validateTempCategoryName.bind(this);
        this.resetTempCategoryNameValidation = this.resetTempCategoryNameValidation.bind(this);

        this.showErrorPopup = this.showErrorPopup.bind(this);
        this.resetCategoryNameInput = this.resetCategoryNameInput.bind(this);
    }

    componentWillMount() {
        this.loadCategories();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data) {
            this.setState({categories: nextProps.data})
        }
    }

    selectCategory(event) {
        let selected = event.target.value;
        let newCat = [...this.state.categories];
        newCat.push(selected);
        this.setState({categories: newCat, selectedCategory: SELECT_OPTION});
        if (this.props.handleChange) {
            this.props.handleChange("categoryIds", newCat, 'Entities_Review_UIText_reviewCompanies.categoryAssignmentSuccessful');
        }
    }

    loadCategories() {
        this.props.spinner.showSpinner();
        categoriesApi
            .getCategoryNames()
            .then((categoryStore) => {
                this.setState({categoryStore: categoryStore});
                this.props.spinner.hideSpinner();
            }).catch((error) => {
            this.props.spinner.hideSpinner();
            xhr.handleAllErrors(error);
        });
    }

    testCategory(event) {
        let categoryId    = event.target.getAttribute('data-category-id'),
            categoryIds   = [...this.state.categories],
            categoryIndex = utils.inArray(categoryId, categoryIds);

        // create new entity
        if(!this.state.entityId) {
            if (categoryIndex > -1) {
                categoryIds.splice(categoryIndex, 1);
                this.setState({categories: categoryIds, clickedCategoryId: categoryId});
                if (this.props.handleChange) {
                    this.props.handleChange("categoryIds", categoryIds, 'Entities_Review_UIText_reviewCompanies.categoryUnassignmentSuccessful');
                }
            }
            return;
        }

        // edit entity
        categoriesApi.getCategoryData(categoryId)
            .then((response) => {
                //check if the category only has 1 entity assigned to it, to show the warning modal
                if (response.body.companies && response.body.companies.length > 1) {
                    if (categoryIndex > -1) {
                        categoryIds.splice(categoryIndex, 1);
                        this.setState({categories: categoryIds, clickedCategoryId: categoryId});
                        if (this.props.handleChange) {
                            this.props.handleChange("categoryIds", categoryIds,
                                'Entities_Review_UIText_reviewCompanies.categoryUnassignmentSuccessful');
                        }
                    }
                } else {
                    this.setState({
                        clickedCategoryId:   categoryId,
                        clickedCategoryName: this.state.categoryStore[categoryId]
                    });
                    let props = {
                        entityName: this.props.companyTitle,
                        categoryName: this.state.categoryStore[categoryId],
                        categoryId,
                        isModalLoading: true,
                        secondaryAction: this.closeModal
                    };

                    this.showOrphanedCategoryModal(props);
                    utils.checkCategoryLinks(categoryId)
                        .then((response) => {
                            props.isModalLoading = false;
                            props.primaryAction = () => {
                                this.removeCategory();
                                this.closeModal();
                            }

                            if(response.count > 0) {
                                props.totalCount = response.count;
                                props.listItems = response.list;
                                this.showLinkedOrphanedCategoryModal(props);
                            } else {
                                this.showOrphanedCategoryModal(props);
                            }
                        });
                }
            });
    }

    toggleOrphanCategoryModal() {
        this.setState({orphanCategoryModal: !this.state.orphanCategoryModal})
    }

    toggleOrphanCategoryLinkedModal() {
        this.setState({orphanCategoryLinkedModal: !this.state.orphanCategoryLinkedModal})
    }

    removeCategory() {
        let categoryId    = this.state.clickedCategoryId,
            categoryIds   = [...this.state.categories],
            categoryIndex = utils.inArray(categoryId, categoryIds);

        if (categoryIndex > -1) {
            categoryIds.splice(categoryIndex, 1);
            this.setState({categories: categoryIds, clickedCategoryId: categoryId});
            if (this.props.handleChange) {
                this.props.handleChange("categoryIds", categoryIds, 'Entities_Review_UIText_reviewCompanies.categoryUnassignmentSuccessful');
            }
        }

        if (this.state.orphanCategoryModal) {
            this.toggleOrphanCategoryModal();
        }
        if (this.state.orphanCategoryLinkedModal) {
            this.toggleOrphanCategoryLinkedModal();
        }

    }

    generateCategoryOptions() {
        let categoryStore = this.state.categoryStore;

        let categoryOptions = [];
        for (let categoryId in categoryStore) {
            //exclude already selected categories from the dropdown elements
            if (categoryStore.hasOwnProperty(categoryId) && !this.state.categories.find(category => category === categoryId)) {
                categoryOptions.push(
                    <option key={'category-option-' + categoryId}
                            value={categoryId}>
                        {categoryStore[categoryId]}
                    </option>
                );
            }
        }
        return categoryOptions;
    }

    generateCategoryLabels() {
        let categoryLabels = [];
        let categoryIds = this.state.categories;
        let categoryStore = this.state.categoryStore;

        if (categoryIds && categoryStore) {
            for (let i = 0; i < categoryIds.length; i++) {
                let categoryId   = categoryIds[i],
                    categoryName = categoryStore[categoryId];

                if (categoryId && categoryName) {
                    categoryLabels.push(
                        <span className="tags-label notranslate" title={categoryName} key={'category-label-' + i}>
                            {categoryName}
                            <span className="tags-label__close-button la-CloseRemove"
                                  data-category-id={categoryId}
                                  onClick={this.testCategory}>
                            </span>
                        </span>
                    );
                }
            }
        }

        return categoryLabels;
    }

    setTempCatName(data) {
        let name = data.name;
        this.setState({ tempCatName: name });
    }

    removeTempCategory(event){

        let categoryId    = event.target.getAttribute('data-category-id'),
            tempCategories   = [...this.state.tempCategoriesNames],
            categoryIndex = utils.inArray(categoryId, tempCategories);

        if (categoryIndex > -1) {
            tempCategories.splice(categoryIndex, 1);
            this.setState({tempCategoriesNames: tempCategories});
            if (this.props.handleChange) {
                this.props.handleChange("tempCategories", tempCategories, 'Entities_Review_UIText_reviewCompanies.categoryUnassignmentSuccessful');
            }
        }
    }

    generateTempCategoryLabels() {
        let tempCategoryLabels = [];
        let tempCategoryStore = this.state.tempCategoriesNames;

        for (let i = 0; i< tempCategoryStore.length; i++) {
            tempCategoryLabels.push(
                <span className="tags-label notranslate" title={tempCategoryStore[i]} key={'category-label-' + i}>
                            {tempCategoryStore[i]}
                    <span className="tags-label__close-button la-CloseRemove"
                          data-category-id={tempCategoryStore[i]}
                          onClick={this.removeTempCategory}>
                    </span>
                </span>
            )
        }

        return tempCategoryLabels;
    }

    validateTempCategoryName(inputValue, callback = null) {

        //do not validate if the Category name is empty OR only spaces
        if (!this.state.tempCatName || inputValue.trim().length === 0) {
            this.setState({isTempCategoryNameValid: false});
            return false;
        }

        let tempCategoriesNamesLowercase = [],
            tempCatNameLowercase = this.state.tempCatName.toLowerCase().trim();
        for(let i = 0; i< this.state.tempCategoriesNames.length; i++) {
            tempCategoriesNamesLowercase.push(this.state.tempCategoriesNames[i].toLowerCase().trim())
        }

        //validate with temp categories for duplicate names
        if (tempCategoriesNamesLowercase.find(category => category === tempCatNameLowercase)) {
            this.setState({
                isTempCategoryNameValid:          false,
                errorMessageCategoryName:         'RSS_Add_Error_addRssFeed.feedInfo.unavailableNameError',
                categoryNameValidationIconsState: VALIDATION_ICON_INVALID
            });
            return false;
        }

        this.setState({categoryNameValidationIconsState: VALIDATION_ICON_LOADING});

        categoriesApi.validateNameField(inputValue, null)
            .then((response) => {
                if (response === false) {
                    this.setState({
                        isTempCategoryNameValid:          true,
                        errorMessageCategoryName:         '',
                        categoryNameValidationIconsState: VALIDATION_ICON_VALID
                    }, () => {
                        if (callback) {
                            callback()
                        }
                    });
                    return !response.body;
                }
                this.setState({
                    isTempCategoryNameValid:          false,
                    errorMessageCategoryName:         'RSS_Add_Error_addRssFeed.feedInfo.unavailableNameError',
                    categoryNameValidationIconsState: VALIDATION_ICON_INVALID
                });
                return response.body;
            }).catch((error) => {
            xhr.handleAllErrors(error);
            console.log("********************** Category Name Validation Failed ********************");
        });
    }

    resetCategoryNameInput() {
        this.setState({
            tempCatName:                      '',
            isTempCategoryNameValid:          false,
            categoryNameValidationIconsState: null
        });
    }

    resetTempCategoryNameValidation() {
        this.setState({
            isTempCategoryNameValid:          false,
            categoryNameValidationIconsState: '',
            errorMessageCategoryName:         ''
        });
    }

    addCategory() {
        this.props.companyId ?
            this.createAndAssignCategory() //edit entity page
            :
            this.setCategoryToBeCreatedAndAssigned(); //create entity page
    }

    createAndAssignCategory() {

        categoriesApi.createCategory({name: this.state.tempCatName.trim(), companies: [this.props.companyId]})
            .then((response) => {
                if (response.body && response.body.id) {
                    let selected = response.body.id;
                    let newCat = [...this.state.categories];
                    newCat.push(selected);
                    this.setState({categories: newCat, selectedCategory: SELECT_OPTION});
                    if (this.props.handleChange) {
                        this.props.handleChange("categoryIds", newCat,
                            'Entities_Review_UIText_reviewCompanies.categoryAssignmentSuccessful');
                    }
                    this.loadCategories();
                } else {
                    this.showErrorPopup(codesToMessageIdsMap['none'])
                }
            })
            .catch((error) => {
                if (error.status === 400) {
                    if (error.response.body.validationCode) {
                        let validationCode = error.response.body.validationCode;
                        this.showErrorPopup(codesToMessageIdsMap[validationCode] ?
                            codesToMessageIdsMap[validationCode] : validationCode)
                    } else {
                        this.showErrorPopup(codesToMessageIdsMap['none'])
                    }
                } else {
                    xhr.handleAllErrors(error);
                }
            });

        this.resetCategoryNameInput();
    }

    setCategoryToBeCreatedAndAssigned() {

        let selected = this.state.tempCatName.trim();
        if (selected && this.state.tempCategoriesNames.indexOf(selected) === -1) {
            let newTempCat = [...this.state.tempCategoriesNames];
            newTempCat.push(selected);
            this.setState({tempCategoriesNames: newTempCat, selectedCategory: SELECT_OPTION});
            if (this.props.handleChange) {
                this.props.handleChange("tempCategories", newTempCat,
                    'Entities_Review_UIText_reviewCompanies.categoryAssignmentSuccessful');
            }
        }

        this.resetCategoryNameInput();
    }

    showErrorPopup(messageId) {
        popupActions.setMessages({
            popupTitle: null,
            messages:   [
                {
                    messageId:   messageId,
                    messageType: 'system-error'
                }
            ]
        });

        // Hide the message after 5 seconds.
        setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
    }

    closeModal() {
        this.setState({ activeModal: null });
    }

    showOrphanedCategoryModal(props) {
        this.setState({ activeModal: <ModalRemovedCategoryIsOrphaned {...props} /> });
    }

    showLinkedOrphanedCategoryModal(props) {
        this.setState({ activeModal: <ModalRemovedCategoryIsOrphanedLinked {...props} /> });
    }

    render() {
        let categoryOptions = this.generateCategoryOptions();
        let tempCategoryLabels = this.generateTempCategoryLabels();
        let categoryLabels = this.generateCategoryLabels();
        return (
                <div className="edit-third-party__about__input-group about__categories-input-group">

                    <label className="row-label" htmlFor='edit-third-party__select-category'>
                        <b><FormattedMessage id="Entities_Edit_UIText_editThirdParty.categoriesLabel" /></b>
                    </label>

                    {
                        categoryOptions ?

                            <div className="edit-third-party__about__category-select-row">
                                <div className='assign-to-label'>
                                    <FormattedMessage id="General_CoreFunctionality_UIText_general.addToCategory" />
                                </div>
                                <select id="edit-third-party__select-category"
                                        className="edit-third-party__select-category qa-category-select notranslate"
                                        disabled={categoryOptions.length <= 0}
                                        name="assignToCategory"
                                        value={this.state.selectedCategory}
                                        title={this.props.intl.formatMessage(
                                            {id: 'General_CoreFunctionality_UIText_general.addToCategory'})}
                                        onChange={this.selectCategory}>
                                    <option disabled value={SELECT_OPTION}>
                                        {this.props.intl.formatMessage(
                                            {id: 'General_CoreFunctionality_UIText_general.selectCategory'})}
                                    </option>
                                    {categoryOptions}
                                </select>

                            </div>
                            :
                            null
                    }

                    <label className="row-label or">
                        <FormattedMessage id="General_CoreFunctionality_UIText_general.or" />
                    </label>

                    <div className='edit-third-party__about__category-create-row'>
                        <div className='create-new-category-label'>
                            <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.companies.createNewCategory" />
                        </div>

                        <CategoryName data={{name: this.state.tempCatName}}
                                      saveData={this.setTempCatName}
                                      validateCategoryNameSection={this.validateTempCategoryName}
                                      resetCategoryNameValidation ={this.resetTempCategoryNameValidation }
                                      categoryNameValidationIconsState={this.state.categoryNameValidationIconsState}
                                      errorMessage={this.state.errorMessageCategoryName} />

                    </div>

                    <button type="button"
                        className={'button-doc-sm' +
                            (!this.state.isTempCategoryNameValid ? ' disabled' : '')}
                            onClick={this.addCategory}>
                        <FormattedMessage id="Entities_Preview_UIText_previewCompanies.panel.add" />
                    </button>

                    <label className="row-label">
                        <FormattedMessage id="General_CoreFunctionality_UIText_general.categoriesAssigned" />:
                    </label>
                    <div className="edit-third-party__about__category-labels">
                        {categoryLabels.length > 0 ? categoryLabels : null}
                        {tempCategoryLabels.length > 0 ? tempCategoryLabels : null}
                        {
                            categoryLabels.length > 0 || tempCategoryLabels.length > 0 ?
                                null
                                :
                                <i><FormattedMessage id='General_CoreFunctionality_UIText_general.noCategoriesAssigned' /></i>
                        }
                    </div>

                    {
                        this.state.orphanCategoryModal ?
                            <ModalRemovedCategoryIsOrphaned
                                isModalLoading={this.state.isModalLoading}
                                primaryAction={this.removeCategory}
                                secondaryAction={this.toggleOrphanCategoryModal}
                                categoryName={this.state.clickedCategoryName}
                                entityName={this.state.entityName} />
                            :
                            null
                    }

                    {
                        this.state.orphanCategoryLinkedModal ?
                            <ModalRemovedCategoryIsOrphanedLinked
                                isModalLoading={this.state.isModalLoading}
                                primaryAction={this.removeCategory}
                                secondaryAction={this.toggleOrphanCategoryLinkedModal}
                                categoryName={this.state.clickedCategoryName}
                                entityName={this.state.entityName} />
                            :
                            null
                    }

                    {this.state.activeModal && this.state.activeModal}

                </div>
        );
    }
}

export default injectIntl(Spinnable(EditCategories));


// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/EditCategories.jsx